module.exports = __webpack_public_path__ + "static/media/02-1-galeria-03-saint-laurent@2x.e3369861.jpg";